// 1.ajax工具函数层
import Axios from "axios";
// 2.服务器地址
const request = Axios.create({
  baseURL: 'https://erf.zglife.com.cn/prod-api/'//生产环境
  // baseURL: 'https://erf.gazo.net.cn:8809/test-api/'//测试环境
  // baseURL: 'http://192.168.130.13/dev-api/bdj/'
  // baseURL: 'http://192.168.130.13/dev-api/cyf/'//cyf
})
// 3.超时时间、
request.defaults.timeout = 30000

// 4.请求拦截器
request.interceptors.request.use((config) => {
  config.headers.TerminalId = '520588b49907406e8d8773321cf59e78';
  return config
}, (err) => {
  return Promise.reject(err)
})

// 5.响应拦截器
request.interceptors.response.use((response) => {
  return response
}, (err) => {
  return Promise.reject(err)
})

export default request
